import { Image } from "antd-mobile";
import img from "app/img";
import { useNavigate } from "react-router-dom";

export type BannerData = {
  src?: string;
  onClick?: () => {};
};

const Logo: React.FC<BannerData> = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <center>
        <Image
          fit="cover"
          width={80}
          src={props.src ? props.src : img.logo}
          onClick={
            props.onClick
              ? props.onClick
              : () => {
                  navigate("/");
                }
          }
        />
      </center>
    </>
  );
};

export default Logo;
